import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchExchangePrice, getIsAutoReplaceExchangePrices } from '@entities/exchange';
export function useAutoReplaceExchangePrices() {
    const dispatch = useDispatch();
    const isAutoReplaceExchangePrices = useSelector(getIsAutoReplaceExchangePrices);
    useEffect(() => {
        if (!isAutoReplaceExchangePrices) {
            return;
        }
        dispatch(fetchExchangePrice());
    }, [dispatch, isAutoReplaceExchangePrices]);
}
